import * as React from "react";
import classnames from "classnames";
import { Button, Modal } from "@grandvisionhq/common";
import { SupportedCodeFormats, useCodeScannerCamera, CodeScannerCamera } from "@grandvisionhq/elements";
/* empty css                              */
const VoucherScannerAndTrigger = ({
  className,
  onCodeDetected,
  onError,
  labels
}) => {
  const formatsToSupport = [SupportedCodeFormats.CODE_128];
  const [isVoucherModalOpen, setIsVoucherModalOpen] = React.useState(false);
  const cameraContainerRef = React.useRef(null);
  const handleCodeDetected = React.useCallback(
    (decodedText) => {
      onCodeDetected(decodedText);
      setIsVoucherModalOpen(false);
    },
    [setIsVoucherModalOpen, onCodeDetected]
  );
  const { stopScanner, initScanner, cameraError, status } = useCodeScannerCamera({
    onError,
    onCodeDetected: handleCodeDetected,
    formatsToSupport,
    cameraContainerRef
  });
  const handleModalClose = React.useCallback(() => {
    if (status === "scanning" || status === "error" || status === "stopped") {
      stopScanner();
      setIsVoucherModalOpen(false);
    }
  }, [status, stopScanner]);
  const triggerVoucherModal = React.useCallback(() => {
    setIsVoucherModalOpen(true);
    initScanner();
  }, [initScanner]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      className: classnames("voucher-scanner__trigger", className),
      caption: labels.triggerButtonCaption,
      onClick: triggerVoucherModal,
      icon: "qrScan",
      variant: "outline"
    }
  ), /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "voucher-scanner__modal",
      "data-t": "voucher-scanner-modal",
      isOpen: isVoucherModalOpen,
      onModalClose: handleModalClose,
      preventVerticalScroll: true,
      showIcon: true,
      title: labels.modalTitle
    },
    /* @__PURE__ */ React.createElement(
      CodeScannerCamera,
      {
        cameraError,
        status,
        labels,
        cameraContainerRef
      }
    )
  ));
};
export {
  VoucherScannerAndTrigger
};
//# sourceMappingURL=VoucherScannerAndTrigger.js.map
